/**
 * AA IDP 404
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class FourOhFour extends React.Component {
  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "ErrorBoundary",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: "triangle-exclamation"
      }), /*#__PURE__*/_jsx("div", {
        className: "apologies",
        children: /*#__PURE__*/_jsx("h2", {
          children: "Error 404 | Page not found"
        })
      })]
    });
  }
}
export default FourOhFour;